
import React, { useEffect, useState, useRef } from "react";
import API from "../Services/Auth"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import APIS from '../Services/Location'
import APISS from '../Services/Report'

const Dashboard = () => {
  const [total, setTotal] = useState();
  const [cardTotal, setCardTotal] = useState()
  const [locationTotal, setTotalLocation] = useState()
  const [summary, setSummary] = useState("")
  const [currentDate, setCurrentDate] = useState(getDate());
  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      bindCustomerData();
      bindCardsData()
      getLocationList()
      getSummaryReport()
    }
  }, [])

  const bindCustomerData = async () => {
    try {
      const payload = {
        limit: 0,
        pageNumber: 1,
        search: "",
        from_date:null,
        to_date:null,
        location_id:null
      };

      const response = await API.getCustomerData(payload);
      // console.log("Response:", response.data.total_count);
      setTotal(response.data.total_count);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 500) {
          toast.error("Server Error (500): Something went wrong on the server.");
        } else if (error.response.status === 403) {
          window.location.replace("/Login");
        } else {
          toast.error(`Error (${error.response.status}):`, error.response.data);
        }
      } else {
        toast.error("Network error or request failed:", error.message);
      }
    }
  };

  const bindCardsData = async () => {
    try {
      const payload = {
        limit: 10,
        pageNumber: 1,
        search: "",
      };

      const response = await API.getCards(payload);
      // console.log("Response:", response.data.total_count);
      setCardTotal(response.data.total_count);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 500) {
          toast.error("Server Error (500): Something went wrong on the server.");
        } else if (error.response.status === 403) {
          window.location.replace("/Login");
        } else {
          toast.error(`Error (${error.response.status}):`, error.response.data);
        }
      } else {
        toast.error("Network error or request failed:", error.message);
      }
    }
  };

  const getLocationList = async () => {
    try {
      const payload = {
        limit: 10,
        pageNumber: 1
      };

      const response = await APIS.getLocationList(payload);
      setTotalLocation(response?.data?.totalCount);
    } catch (error) {
      if (error.response.status === 403) {
        window.location.replace("/Login");
      }
      console.error("Error fetching location list:", error);
    }
  };

  function getDate() {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const year = today.getFullYear();
    const date = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${date}`;
  }


  const getSummaryReport = async () => {
    // console.log(".........", currentDate)
    const payload = {
      end_date: currentDate,
      start_date: currentDate,
      location_id: null
    }
    // console.log("payload..", payload)
    // return;
    try {
      const response = await APISS.getSummary(payload);

      if (response?.status === 200 && response?.data?.result) {
        const parsedData = Object.fromEntries(
          Object.entries(response.data.result).map(([key, value]) => {
            try {
              const parsedValue = JSON.parse(value);
              return [key, parsedValue];
            } catch {
              return [key, value];
            }
          })
        );
        setSummary(parsedData);
       // console.log('parsedData', parsedData);
        // toast.success("Summary report loaded successfully!");
      } else {
        setSummary({});

        toast.error("No summary data found!");
      }
    } catch (error) {
      console.error("Error fetching summary report:", error);
      toast.error("Failed to fetch summary report!");
      setSummary({});

    }
  };
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <a className="btn btn-success" href="ManagerCard">Issue Manager Card</a>
      </div>
      <div className="row mt-2">

        <div className="col-md-4 stretch-card grid-margin">
          <div className="card bg-gradient-danger card-img-holder text-white">
            <div className="card-body">

              <h4 className="font-weight-normal mb-3">Total Customer <i className="mdi mdi-account-circle mdi-24px float-end"></i>
              </h4>
              <h2>{total}</h2>

            </div>
          </div>
        </div>
        <div className="col-md-4 stretch-card grid-margin">
          <div className="card bg-gradient-info card-img-holder text-white">
            <div className="card-body">
              <h4 className="font-weight-normal mb-3">Total Card <i className="mdi mdi-credit-card-multiple mdi-24px float-end"></i>
              </h4>
              <h2>{cardTotal}</h2>

            </div>
          </div>
        </div>
        <div className="col-md-4 stretch-card grid-margin">
          <div className="card bg-gradient-success card-img-holder text-white">
            <div className="card-body">
              <h4 className="font-weight-normal mb-3">Today Sales <i className="mdi mdi-sale mdi-24px float-end"></i>
              </h4>
              <h2>₹{summary?.direct_transaction?.amount || 0.00}</h2>
              {/* <h6 className="card-text">Increased by 5%</h6> */}
            </div>
          </div>
        </div>
      </div>

      <div className="row">

        <div className="col-md-4 stretch-card grid-margin">
          <div className="card bg-gradient-primary card-img-holder text-white">
            <div className="card-body">
              <h4 className="font-weight-normal mb-3">Total Center <i className="mdi mdi-crosshairs-gps mdi-24px float-end"></i>
              </h4>
              <h2>{locationTotal}</h2>
            
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>

  );
};

export default Dashboard;